// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList
}                         from '../../../components';
import styles                 from './style';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import Dialog from 'material-ui/Dialog';
import { Multiselect } from 'react-widgets';
import CreateFixture from '../../partner/crud/createFixture';
import PartnerAllocation from '../../partner/partnerAllocation';
import ReplaceBuddy from '../crud/replaceBuddy';
import AddBuddy from '../crud/addBuddy';
import HostGame from '../../partner/crud/hostGame';

class FixtureInfo extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props)
    this.state = {
      game_type:'Academy',
      session_id:'',
      fixture_id:'',
      venue : this.props.match.params.id,
      session_data:[],
      buddies:[],
      selected_buddies: [],
      temp_buddies: [],
      fixture_groups: [],
      filtered_data:[],
      filtered_session:[],
      hosted_games:[],
      fixture_list: true,
      session_list: false,
      fixtue:false,
      allocation:false,
      add_buddy:false,
      replace:false,
      hosted_game:false,
      host_game: false,
      loading: true,
      fix_success: false,
      sess_success: false,
      host_success:false,
      buddy_dialog: false,
      dialog_delete: false,
      delete_fixture: false,
      selected_tab:props.match.params.selected_tab,
      selected_fixtures:[],
      selected_sessions:[]
    };
    this.onSelect = this.onSelect.bind(this);
    this.onChange = this.onChange.bind(this);
    this.postBuddies = this.postBuddies.bind(this);
    this.deleteSession = this.deleteSession.bind(this);
    this.deleteFixture = this.deleteFixture.bind(this);
    this.handleFixtureEdit = this.handleFixtureEdit.bind(this);
    this.handleFixtureDelete = this.handleFixtureDelete.bind(this);
    this.handleSelection = this.handleSelection.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSessionSearch = this.handleSessionSearch.bind(this);
    this.handleTypeSelection = this.handleTypeSelection.bind(this);
  }

  componentWillMount() {
    // const { actions: { enterPage } } = this.props;
    // enterPage('Home');
  }

  componentDidMount() {
    this.getAllBuddies();
    console.log('ddmt')
    console.log(this.state.selected_tab)
    if(this.state.selected_tab == 'fixture_list'){
      this.setState({replace:false,fixture_list:true,session_list:false,allocation:false,fixture:false,add_buddy:false,host_game:false,hosted_game:false})
      }
    else if(this.state.selected_tab == 'session_list'){
      this.setState({replace:false,fixture_list:false,session_list:true,allocation:false,fixture:false,add_buddy:false,host_game:false,hosted_game:false})
    }
    else if(this.state.selected_tab == 'allocation'){
      this.setState({replace:false,fixture_list:false,session_list:false,allocation:true,fixture:false,add_buddy:false,host_game:false,hosted_game:false})
    }
    else if(this.state.selected_tab == 'hosted_game'){
      this.setState({replace:false,fixture_list:false,session_list:false,allocation:false,fixture:false,add_buddy:false,host_game:false,hosted_game:true})
    }
    else if(this.state.selected_tab == 'fixture'){
      this.setState({replace:false,fixture_list:false,session_list:false,allocation:false,fixture:true,add_buddy:false,host_game:false,hosted_game:false})
    }
    else if(this.state.selected_tab == 'replace'){
      this.setState({replace:true,fixture_list:false,session_list:false,allocation:false,fixture:false,add_buddy:false,host_game:false,hosted_game:false})
    }
    else if(this.state.selected_tab == 'add_buddy'){
      this.setState({replace:false,fixture_list:false,session_list:false,allocation:false,fixture:false,add_buddy:true,host_game:false,hosted_game:false})
    }
    else if(this.state.selected_tab == 'host'){
      this.setState({replace:false,fixture_list:false,session_list:false,allocation:false,fixture:false,add_buddy:false,host_game:true,hosted_game:false})
    }
  }

  componentWillUnmount() {
    // const { actions: { leavePage } } = this.props;
    // leavePage('Home');
  }

  getSessions(){
    const url = `${getLocationOrigin()}/cm/get_allocated_buddies/?venue=${this.state.venue}&game_type=${this.state.game_type}`;
    const options = {...defaultOptions};

    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
        console.log('result',data)
        this.setState({session_data:data.sorted_list,sess_success: data.success,filtered_session:data.sorted_list});
        }).catch(error => error);
    }


  handleSearch(event){
    const search = event.target.value.toLowerCase()
    var search_list = []

    if(search == ''){
      var search_list = this.state.fixture_groups 
    }
    else{

      const filter_result_gametype = this.state.fixture_groups.filter((game)=>{
        return game.game_type_str.toLowerCase().indexOf(search) !== -1;
        }
      );
      
      const filter_result_level = this.state.fixture_groups.filter((level)=>{
        return level.game_level_str.toLowerCase().indexOf(search) !== -1;
        }
      );

      for(let i=0; i< filter_result_gametype.length; i++){
        if(search_list.indexOf(filter_result_gametype[i]) === -1) { 
            search_list.push(filter_result_gametype[i])
        }
      }

      for(let i=0; i< filter_result_level.length; i++){
        if(search_list.indexOf(filter_result_level[i]) === -1) { 
            search_list.push(filter_result_level[i])
        }
      }     
    }
    search_list.sort((a,b) => a['game_type_str'].localeCompare(b['game_type_str']))
    this.setState({filtered_data:search_list,search:search})
  }

  handleSessionSearch(event){
    const search = event.target.value.toLowerCase()
    var search_list = {}
    if(search == ''){
      search_list = this.state.session_data 
    }
    else{
      var keys = Object.keys(this.state.session_data)
      for(var i = 0; i< keys.length; i++){
        if ((this.state.session_data[keys[i]].type.toLowerCase().indexOf(search) !== -1) == true){
          search_list[keys[i]] = this.state.session_data[keys[i]]
        } 
      }    
    }   
    this.setState({filtered_session:search_list,search:search})
  }

  getAllBuddies(){
    const url = `${getLocationOrigin()}/cm/get_buddies/?venue=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
        console.log('result',data)
        this.setState({buddies:data.buddies},()=>{this.getSessions()});
    }).catch(error => error);
    }

  getFixtureGroups(){
    const url = `${getLocationOrigin()}/cm/get_fixture_groups/?venue=${this.state.venue}&game_type=${this.state.game_type}`;
    const options = {...defaultOptions};

    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
        console.log('result',data)
        data.result.sort((a,b) => a['game_type_str'].localeCompare(b['game_type_str']))
        this.setState({fixture_groups:data.result,filtered_data:data.result,fix_success:data.success});
    }).catch(error => error);
  }

  getHostedGames(){
    const url = `${getLocationOrigin()}/cm/get_hosted_games/?venue=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
        console.log('result',data)
        this.setState({hosted_games:data.result,host_success:data.success});
    }).catch(error => error);
  }

  postBuddyChange(buddies,session_id){
    const url = `${getLocationOrigin()}/cm/allocate_buddy_to_session/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'buddies': buddies,
                        'session_id': session_id,
                      });
    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
        if(data.success){
          alert(data.message)
          this.setState({buddy_dialog:false},()=>{this.getSessions()})
          
        }
        else{
          this.setState({buddy_dialog:false})
          alert(data.message)
        }

    }).catch(error => error);
  }

  deleteSession(){
    const url = `${getLocationOrigin()}/cm/delete_session/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'session_id': this.state.session_id,
                      });
    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
        if(data.success){
          alert(data.message)
          this.setState({dialog_delete:false})
          this.getSessions()
          this.renderSessions()
        }
        else{
          this.setState({dialog_delete:false})
          alert(data.message)
        }

    }).catch(error => error);
  }

  deleteFixture(){
    const url = `${getLocationOrigin()}/cm/delete_hosted_game/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'fixture_id': this.state.fixture_id,
                      });
    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
        if(data.success){
          alert(data.message)
          this.setState({delete_fixture:false},()=>{this.getHostedGames()})
          
        }
        else{
          this.setState({delete_fixture:false})
          alert(data.message)
        }

    }).catch(error => error);
  }

  postBuddies(){
    var bud_ids = []
    for( var i in this.state.selected_buddies)
    {
      bud_ids.push(this.state.selected_buddies[i].id)
    }
    console.log('ids',bud_ids)
    this.postBuddyChange(bud_ids,this.state.session_id)
  }

  onSelect(optionsList, selectedItem) {
      this.state.temp_buddies.push(optionsList)
      this.setState({ selected_buddies: this.state.temp_buddies});
  }

  onChange(dataItem,event){
    this.setState({selected_buddies:dataItem.map(x =>x)});
  }

  handleBuddy(session_id,key) {
    console.log('session_id',session_id)
    var bud_ids = this.state.session_data[key].buddy
    const sel_buds = this.state.buddies.filter(buddy=> bud_ids.includes(buddy.id))
    console.log('sel_buds',sel_buds)
    this.setState({selected_buddies:sel_buds,session_id:session_id,buddy_dialog:true})
  }

  handleSessionDelete(session_id) {
    console.log('handleSessionDelete..')
    console.log(session_id)
    this.setState({session_id:session_id,dialog_delete:true})
  }

  handleFixtureEdit(event){
    const id = event.target.value
    window.location.href = `./#/crud/editFixture/${id}`
  }

  handleFixtureDelete(event){
    const id = event.target.value
    window.location.href = `./#/crud/deleteFixture/${id}`
  }

  handleHostedEdit(event){
    const id = event.target.value
    window.location.href = `./#/crud/editHostedGame/${id}`
  }

  handleHostedDelete(fixture_id) {
    this.setState({fixture_id:fixture_id,delete_fixture:true})
  }

  handleTypeSelection(event){
    const name = event.target.name
    if(name == 'type_academy'){
      this.setState({game_type:'Academy'},()=>this.getFixtureGroups())
    }
    else if(name == 'type_improve'){
      this.setState({game_type:'Improve'},()=>this.getFixtureGroups())

    }
    else if(name == 'type_play'){
      this.setState({game_type:'Play'},()=>this.getFixtureGroups())
    }
    else if(name == 'type_session_improve'){
      this.setState({game_type:'Improve'},()=>this.getSessions())

    }
    else if(name == 'type_session_play'){
      this.setState({game_type:'Play'},()=>this.getSessions())
    }
    else if(name == 'type_session_academy'){
      this.setState({game_type:'Academy'},()=>this.getSessions())
    }

  }


  handleSelection(event){
    const name = event.target.name
    if(name == 'fixture'){
      this.setState({fixture:true,fixture_list:false,session_list:false,allocation:false,replace:false,add_buddy:false,host_game:false,hosted_game:false})
      this.props.history.push(`/fixtureInfo/${this.state.venue}/${'fixture'}`)
    }
    else if(name == 'allocation'){
      this.setState({fixture:false,fixture_list:false,session_list:false,allocation:true,replace:false,add_buddy:false,host_game:false,hosted_game:false})
      this.props.history.push(`/fixtureInfo/${this.state.venue}/${'allocation'}`)
    }
    else if(name == 'add_buddy'){
      this.setState({add_buddy:true,replace:false,fixture_list:false,session_list:false,allocation:false,fixture:false,host_game:false,hosted_game:false})
      this.props.history.push(`/fixtureInfo/${this.state.venue}/${'add_buddy'}`)
    }
    else if(name == 'replace'){
      this.setState({replace:true,fixture_list:false,session_list:false,allocation:false,fixture:false,add_buddy:false,host_game:false,hosted_game:false})
      this.props.history.push(`/fixtureInfo/${this.state.venue}/${'replace'}`)
    }
    else if(name == 'fixture_list'){
      this.setState({replace:false,fixture_list:true,session_list:false,allocation:false,fixture:false,add_buddy:false,host_game:false,hosted_game:false})
      this.props.history.push(`/fixtureInfo/${this.state.venue}/${'fixture_list'}`)
    }
    else if(name == 'session_list'){
      this.setState({replace:false,fixture_list:false,session_list:true,allocation:false,fixture:false,add_buddy:false,host_game:false,hosted_game:false})
      this.props.history.push(`/fixtureInfo/${this.state.venue}/${'session_list'}` )
    }
    else if(name == 'host'){
      this.setState({replace:false,fixture_list:false,session_list:false,allocation:false,fixture:false,add_buddy:false,host_game:true,hosted_game:false})
      this.props.history.push(`/fixtureInfo/${this.state.venue}/${'host'}`)
    }
    else if(name == 'hosted_game'){
      this.setState({hosted_game:true,replace:false,fixture_list:false,session_list:false,allocation:false,fixture:false,add_buddy:false,host_game:false})
      this.props.history.push(`/fixtureInfo/${this.state.venue}/${'hosted_game'}`)
    }
  }

  handleOpen=()=>{
    this.setState({buddy_dialog:true})
  }
  handleClose=()=>{
    this.setState({buddy_dialog:false})
  }

  handleDeleteClose = () => {
    this.setState({dialog_delete:false});
  }

  handleDeleteOpen=()=>{
    this.setState({dialog_delete:true})
  }

  handleFixtueDeleteClose = () => {
    this.setState({delete_fixture:false});
  }

  handleFixtureDeleteOpen=()=>{
    this.setState({delete_fixture:true})
  }

  handleCheckbox = (e, s,tag) => {
    var new_value = []
    if(tag === 'fixture'){
      new_value =  Object.assign([], this.state.selected_fixtures);
      const fixtureCheckBox = [...this.state.selected_fixtures];
      if(e.target.checked) {
        fixtureCheckBox.push(s)
      } else {
          const index = fixtureCheckBox.findIndex((ch) => ch === s);
          fixtureCheckBox.splice(index, 1);
      }
      this.setState({selected_fixtures:fixtureCheckBox});
    }
    else if(tag === 'session'){
      new_value =  Object.assign([], this.state.selected_sessions);
      const fixtureCheckBox = [...this.state.selected_sessions];
      if(e.target.checked) {
        fixtureCheckBox.push(s)
      } else {
          const index = fixtureCheckBox.findIndex((ch) => ch === s);
          fixtureCheckBox.splice(index, 1);
      }
      this.setState({selected_sessions:fixtureCheckBox});
    }
  }

  handleBulkDelete = (tag) => {
    let deletion_ids = []
    if(tag == 'fixture'){
      deletion_ids = Object.assign([], this.state.selected_fixtures);
    }
    else if(tag == 'session'){
      deletion_ids = Object.assign([], this.state.selected_sessions);
    }
    var msg = `Are you sure?`;
    var result = confirm(msg);
    if(result === true){
      const url = `${getLocationOrigin()}/cm/bulk_deletion/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                          'tag': tag,
                          'deletion_ids':deletion_ids
                        });
      return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        alert(data.message)
        this.setState({selected_fixtures:[],selected_sessions:[]})
        if(tag=='fixture'){
          this.getFixtureGroups()
          this.renderFixtureGroups()
        }
        else if(tag=='session'){
          this.getSessions()
          this.renderSessions()
        }
        
      }).catch(error => error);
    }
  }

  renderFixtureGroups(){
    console.log('fixture_groups',this.state.filtered_data)
    console.log('sessions',this.state.filtered_session)
    if(this.state.filtered_data.length == 0 && !this.state.fix_success){
      this.getFixtureGroups()
    }
    var header = [' ','Type','Time','Days','Skill Level','Courts','Status','Edit']

    return(
      <div>


        <div className='col-md-12' style={{padding:'0px',width:'100%',marginTop:'1%'}}>
          <button className='button1' style={{marginRight:'1%',background:'#6ad2e6'}} name='type_academy' onClick={this.handleTypeSelection}> Academy </button>
          <button className='button1' style={{marginRight:'1%',background:'#6ad2e6'}} name='type_improve' onClick={this.handleTypeSelection}> Improve </button>
          <button className='button1' style={{marginRight:'1%',background:'#6ad2e6'}} name='type_play' onClick={this.handleTypeSelection}> Play </button>

        </div>




        {
          this.state.selected_fixtures && this.state.selected_fixtures.length > 0 &&
          <div className='col-md-12' style={{display:'flex',justifyContent:'flex-end'}}>
            <button className='button1' style={{'background':'red'}} onClick={()=>this.handleBulkDelete('fixture')}> Delete Selected </button>
          </div>
        }
        <div className='badge badge-success' style={{background:'#3CB3E2',color:'white',padding:'0.8% 1.2%',margin:'1% 0%',display:'flex',flexDirection:'row',float:'left',fontSize:'100%'}}>
         <div style={{alignSelf:'center',fontWeight:'bold'}}>Search - </div> 
          <input name='search' value={this.state.value} onChange={this.handleSearch} style={{color:'black',fontWeight:'500',margin:'0% 1%',width:'72%'}}/> 
        </div>
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={styles.header}>List of Fixtures</div> 
        <table className="table_plain" id="fixture">
          <tr> 
            { header && header.length > 0 &&
              header.map((head)=>
                <th>{head}</th>
                )
             }
          </tr>
          
            { this.state.filtered_data && this.state.filtered_data.length > 0 ?
              this.state.filtered_data.map((data,index)=>
              <tr>
                <td>
                  <input type="checkbox"
                      checked={this.state.selected_fixtures.length > 0 ? this.state.selected_fixtures.find((ch) => ch === data.id):false}
                      onChange={(e) => this.handleCheckbox(e, data.id,'fixture')}
                  />
                </td>
                <td>{data.game_type_str}</td>
                <td>{data.start_time} - {data.end_time} </td>
                <td>{data.days} </td>
                <td>{data.game_level_str}</td>
                <td>{data.no_of_courts}</td>
                <td>{data.status}</td>
                <td>
                  <button className='button1' value={data.id} onClick={this.handleFixtureEdit}>Edit  </button>
                  <button className='button1' value={data.id} onClick={this.handleFixtureDelete} style={{marginTop:'1%'}}>Delete  </button>
                </td>
              </tr>
                )
              :
              this.state.filtered_data.length == 0?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> No Data Available</div>
              </div>
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
            }
        </table>
      </div>
      </div>
      )
  }

  renderHostedGames(){
    console.log('hosted_games',this.state.hosted_games)
    if(this.state.hosted_games.length == 0 && !this.state.host_success){
      this.getHostedGames()
    }
    var header = ['Name','Time','Date','Game Type','Skill Level','Edit']

    return(
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={styles.header}>List of Hosted Games</div> 
        <table className="table_plain">
          <tr> 
            { header && header.length > 0 &&
              header.map((head)=>
                <th>{head}</th>
                )
             }
          </tr>
          
            { this.state.hosted_games && this.state.hosted_games.length > 0 ?
              this.state.hosted_games.map((data,index)=>
              <tr>
                <td>{data.name}</td>
                <td>{data.start_time} - {data.end_time} </td>
                <td>{data.date} </td>
                <td>{data.game_type_str} </td>
                <td>{data.game_level_str}</td>
                <td>
                  <button className='button1' value={data.id} onClick={this.handleHostedEdit}>Edit  </button>
                  <button className='button1' value={data.id} onClick={()=>this.handleHostedDelete(data.id)} style={{marginTop:'1%'}}>Delete  </button>
                </td>
              </tr>
                )
              :
              this.state.hosted_games.length == 0?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> No Data Available</div>
              </div>
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
            }
        </table>
      </div>
      )
  }

  renderSessions(){
    // if(Object.keys(this.state.session_data).length == 0 && !this.state.sess_success){
    //   this.getAllBuddies()
    // }
    var header = [' ','Date','Name','Type','Time','Buddies','Edit']

    return(
      <div>

        <div className='col-md-12' style={{padding:'0px',width:'100%',marginTop:'1%'}}>
          <button className='button1' style={{marginRight:'1%',background:'#6ad2e6'}} name='type_session_academy' onClick={this.handleTypeSelection}> Academy </button>
          <button className='button1' style={{marginRight:'1%',background:'#6ad2e6'}} name='type_session_improve' onClick={this.handleTypeSelection}> Improve </button>
          <button className='button1' style={{marginRight:'1%',background:'#6ad2e6'}} name='type_session_play' onClick={this.handleTypeSelection}> Play </button>

        </div>



      {
        this.state.selected_sessions && this.state.selected_sessions.length > 0 &&
        <div className='col-md-12' style={{display:'flex',justifyContent:'flex-end'}}>
          <button className='button1' style={{'background':'red'}} onClick={()=>this.handleBulkDelete('session')}> Delete Selected </button>
        </div>
      }
      <div className='badge badge-success' style={{background:'#3CB3E2',color:'white',padding:'0.8% 1.2%',margin:'1% 0%',display:'flex',flexDirection:'row',float:'left',fontSize:'100%'}}>
       <div style={{alignSelf:'center'}}>Search - </div> 
        <input name='search' value={this.state.value} onChange={this.handleSessionSearch} style={{color:'black',fontWeight:'500',margin:'0% 1%',width:'72%'}}/> 
      </div>
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={styles.header}>List Of Sessions</div> 
        <table className="table_plain">
          <tr> 
            { header && header.length > 0 &&
              header.map((head)=>
                <th>{head}</th>
                )
             }
          </tr>
          
            { Object.keys(this.state.filtered_session) && Object.keys(this.state.filtered_session).length > 0 ?
              Object.keys(this.state.filtered_session).map((key,index)=>
              <tr>
              <td>
                <input type="checkbox"
                    checked={this.state.selected_sessions.length > 0 ? this.state.selected_sessions.find((ch) => ch === this.state.filtered_session[key].session_id):false}
                    onChange={(e) => this.handleCheckbox(e, this.state.filtered_session[key].session_id,'session')}
                />
              </td>
              <td>{this.state.filtered_session[key].date}</td>
              <td>{this.state.filtered_session[key].name}</td>
              <td>{this.state.filtered_session[key].type} </td>
              <td>{this.state.filtered_session[key].start_time} - {this.state.filtered_session[key].end_time} </td>
              <td>{this.state.buddies.filter(buddy=>this.state.filtered_session[key].buddy.includes(buddy.id)).map((bud,i)=>
                                                <div>{bud.buddy}</div>
                                              )}
              </td>
              <td>
                <button className='button1' onClick={()=>this.handleBuddy(this.state.filtered_session[key].session_id,key)}>Edit  </button>
                <button className='button1' onClick={()=>this.handleSessionDelete(this.state.filtered_session[key].session_id)}>Delete  </button>
              </td>
              </tr>
                )
              :
              Object.keys(this.state.filtered_session).length == 0?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> No Data Available</div>
              </div>
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
            }
        </table>
      </div>
      </div>
      )
  }

  render() {
    console.log('venue',this.props)
    console.log('selected_fixtures',this.state.selected_fixtures)
    const actions = [
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.handleClose}
          />,
          <FlatButton
            label="Proceed"
            primary={true}
            onClick={this.postBuddies}
          />,
        ];

    const delete_actions = [
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.handleDeleteClose}
          />,
          <FlatButton
            label="Delete"
            primary={true}
            onClick={this.deleteSession}
          />,
        ];

    const fixture_delete = [
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.handleFixtueDeleteClose}
          />,
          <FlatButton
            label="Delete"
            primary={true}
            onClick={this.deleteFixture}
          />,
        ];

    return(
          <div className='col-md-12' style={{margin:'2%'}}>
            <div className='col-md-12' style={{padding:'0px',width:'100%'}}>
              <button className='button1' style={{marginRight:'1%'}} name='fixture_list' onClick={this.handleSelection}> Fixtures </button>
              <button className='button1' style={{marginRight:'1%'}} name='session_list' onClick={this.handleSelection}> Sessions </button>
              <button className='button1' style={{marginRight:'1%'}} name='hosted_game' onClick={this.handleSelection}> Hosted Games </button>
              <button className='button1' style={{marginRight:'1%'}} name='host' onClick={this.handleSelection}> Host a Game </button>
              <button className='button1' style={{marginRight:'1%'}} name='fixture' onClick={this.handleSelection}> Add Fixture </button>
              <button className='button1' style={{marginRight:'1%'}} name='allocation' onClick={this.handleSelection}> Add Allocation </button>
              <button className='button1' style={{marginRight:'1%'}} name='add_buddy' onClick={this.handleSelection}> Add Buddy </button>
              <button className='button1' name='replace' onClick={this.handleSelection}> Replace Buddy </button>
            </div>

              {this.state.fixture_list &&
                this.renderFixtureGroups()
              }

              {
                this.state.session_list &&
                this.renderSessions()
              }

              {
                this.state.hosted_game &&
                this.renderHostedGames()
              }

              { this.state.fixture &&
                <CreateFixture venue={this.state.venue}/>
              }

              { this.state.allocation &&
                <PartnerAllocation venue={this.state.venue}/>
              }

              { this.state.add_buddy &&
                <AddBuddy venue={this.state.venue}/>
              }

              { this.state.replace &&
                <ReplaceBuddy venue={this.state.venue}/>
              }

              {
                this.state.host_game &&
                <HostGame venue={this.state.venue}/>
              }

        { this.state.buddy_dialog &&
              <div className="col-md-12">
                <Dialog
                      actions={actions}
                      modal={false}
                      open={this.state.buddy_dialog}
                      onRequestClose={this.handleClose}
                      autoDetectWindowHeight={true}
                      autoScrollBodyContent={true}
                    >
                  <div>
                    <div style={styles.title} className="col-md-12 label_blue_1">
                      <h4 style={{textAlign:'center'}}> Add / Remove Buddies </h4>
                    </div>
                    <div className='col-md-12' style={{marginTop:'2%'}}>
                      <div style={{height:'auto'}} className="col-md-8">
                        <Multiselect
                          id="1"  
                          placeholder="Buddies"
                          data={this.state.buddies}
                          value = {this.state.selected_buddies}
                          textField='buddy'
                          onSelect={this.onSelect} 
                          onChange={this.onChange}
                          filter='contains' 
                         />
                      </div> 

                      <div className='col-md-4'>
                        &larr; Click to add buddy
                      </div>
                    </div>
                    
                  </div> 
                </Dialog>
              </div>
          }

          {
            this.state.dialog_delete &&
              <Dialog
                    actions={delete_actions}
                    modal={false}
                    open={this.state.dialog_delete}
                    onRequestClose={this.handleDeleteClose}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}
                  >
                <div >
                  <div style={styles.main_header,{justifyContent:'center'}} className="col-md-12 label_blue_1">
                    <h4 style={{textAlign:'center'}}> Delete Record </h4>
                  </div>
                  <div className='col-md-12' style={{marginTop:'2%'}}>Are you sure you want to delete ? </div>
                </div>
              </Dialog>
          }

          {
            this.state.delete_fixture &&
              <Dialog
                    actions={fixture_delete}
                    modal={false}
                    open={this.state.delete_fixture}
                    onRequestClose={this.handleFixtueDeleteClose}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}
                  >
                <div >
                  <div style={styles.main_header,{justifyContent:'center'}} className="col-md-12 label_blue_1">
                    <h4 style={{textAlign:'center'}}> Delete Record </h4>
                  </div>
                  <div className='col-md-12' style={{marginTop:'2%'}}>Are you sure you want to delete ? </div>
                </div>
              </Dialog>
          }
      </div>
    );
  }
}

export default FixtureInfo;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/FixtureInfo/FixtureInfo.js